import React from 'react'
import { Link } from 'react-static'

import SectionTitle from 'components/Section-Title'
import ColorBar from 'components/Color-Bar'

import contentImageUrl from '../static/img/content-asset-management.jpg'

class AssetManagement extends React.Component {
  render() {
    return (
      <React.Fragment>
        <ColorBar />

        <div className="container container--grey">
          <SectionTitle
            icon="icon-asset-management.svg"
            title="Asset Management"
          />

          <div className="layout layout--content">
            <div className="layout__item layout__item--half">
              <p>Our philosophy is centred on finding the right balance in the current difficult market to match the requirements of the occupational and funding markets. Therefore investment selection is key.</p>
              <p><img src={contentImageUrl} alt="" /></p>
            </div>
            <div className="layout__item layout__item--half">
              <p>To support this we can provide Strategic Advice, Financial Analysis, Market Intelligence and Asset Planning to cover the following areas</p>
              <ul>
                <li>Leasing strategy/regearing</li>
                <li>exit strategy and implementation</li>
                <li>property development</li>
                <li>property marketing</li>
                <li>refurbishment/estate works</li>
                <li>planning overview</li>
                <li>joint venture initiatives</li>
                <li>master planning service</li>
                <li>marriage value negotiations</li>
                <li>building design</li>
                <li>co-ordination of professional team</li>
                <li>rent reviews</li>
              </ul>
              <p>Our sites vary from greenfield sites being promoted through the local planning process to up and let investments requiring the full spectrum of services above</p>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default AssetManagement;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Asset-Management.js